import { createAction } from "./base";

const GetAllBudgetsAction = createAction('GetAllBudgetsAction');
const GetArchiveBudgetsAction = createAction('GetArchiveBudgetsAction');
const GetBudgetResultsAction = createAction('GetBudgetResultsAction');

function getAllBudgets(filter) {
	return {
		type: GetAllBudgetsAction.Request,
		payload: filter
	};
}

function getBudgetResults(budgetId) {
	return {
		type: GetBudgetResultsAction.Request,
		payload: budgetId
	}
}

function getArchiveBudgets(filter) {
	return {
		type: GetArchiveBudgetsAction.Request,
		payload: filter
	}
}

export const BudgetActionCreators = {
	getAllBudgets,
	getBudgetResults,
	getArchiveBudgets
};

export const BudgetActions = {
	GetAllBudgetsAction,
	GetBudgetResultsAction,
	GetArchiveBudgetsAction
};
